﻿const axios = require('axios');

const changePasswordApp = {
    data() {
        return {
            api: '',
            username: '',
            email: '',
            modalActive: false
        }
    },
    methods: {
        async submitPasswordRequest() {
            const response = await this.fetchData({ username: this.username }, this.api, 'post');
            if (response.status === 200) {
                this.modalActive = true;
            }
        },
        async fetchData(formData, apiUrl, methodType) {
            try {
                const response = await axios({
                    method: methodType,
                    url: apiUrl,
                    data: formData,
                    headers: { 'Content-Type': 'application/json' },
                })
                return response;
            } catch (error) {
                console.log(error);
            }
        }
    },
    mounted() {
        if (sessionStorage.getItem('user') !== null) {
            this.username = JSON.parse(sessionStorage.getItem('user')).username;
            this.email = JSON.parse(sessionStorage.getItem('user')).email;
        }
        if (this.$el.parentNode.dataset.api) this.api = this.$el.parentNode.dataset.api;
    }
}

export default changePasswordApp;